<template lang="pug">
  el-table(
    style='width: 100%;'
    header-cell-class-name='table-header'
    cell-class-name='pl-4'
    :data='transmitters'
    @selection-change="$emit('selectionChange', $event)"
  )
    el-table-column(
      width="55"
    )
      template(slot-scope='scope')
        span.pre-line {{ scope.$index + 1}}
    el-table-column(
      prop='name'
      :label="$t('transmitters.label.name')"
    )
      template(slot-scope='scope')
        span.cursor-pointer.text-underline(v-if="scope.row.name" @click="handleOpenEditTransmitter(scope.row)") {{ scope.row.name }}
        span(v-else) -
    el-table-column(
      prop='dev_eui'
      :label="$t('transmitters.label.dev_eui')"
    )
      template(slot-scope='scope')
        span(v-if="scope.row.dev_eui") {{ scope.row.dev_eui }}
        span(v-else) -
    el-table-column(
      prop='site'
      :label="$t('transmitters.label.site')"
    )
      template(slot-scope='scope')
        div(v-if="scope.row.site")
          img.ml-1(
            src="@assets/site.svg"
            :title="'Site'"
          )
          span {{ " " + scope.row.site.name }}
          br
          img.ml-1(
            v-if="scope.row.field"
            src="@assets/field.svg"
            :title="'Field'"
          )
          span(v-if="scope.row.field") {{ " " + scope.row.field.name }}
          span(v-else) -
        span(v-else) -
    el-table-column(
      prop='firmware_version'
      :label="$t('transmitters.label.firmware_version')"
    )
      template(slot-scope='scope')
        span.cursor-pointer(v-if="scope.row.firmware_version" @click="handleOpenViewBatteryDialog(scope.row)") {{ buildDateTime(scope.row.firmware_version) }}
        span(v-else) -
    el-table-column(
      prop='sensors_count'
      :label="$t('transmitters.label.battery')"
      width="130px"
    )
      template(slot-scope='scope')
        span.cursor-pointer(@click="handleOpenViewBatteryDialog(scope.row)")
          BatteryIcon(:battery="scope.row.bat_voltage")
    el-table-column(
      prop='sensors_count'
      :label="$t('transmitters.label.sensors_count')"
      width="130px"
    )
      template(slot-scope='scope')
        span(v-if="scope.row.sensors_count >= 0") {{ scope.row.sensors_count }}
        span(v-else) -
    el-table-column(
      prop='actions'
      :label="$t('transmitters.label.actions')"
    )
      template(v-slot='scope')
        .grid-buttons
          img.cursor-pointer.ml-1(
            src="@assets/actions/config.svg"
            :title="$t('transmitters.edit_transmitter_config')"
            @click="handleOpenEditTransmitterConfig(scope.row)"
          )
          img.cursor-pointer.ml-1(
            src="@assets/actions/edit.svg"
            :title="$t('transmitters.edit_transmitter')"
            @click="handleOpenEditTransmitter(scope.row)"
          )
          img.cursor-pointer.ml-1(
            src="@assets/actions/soil-sensors.svg"
            :title="$t('transmitters.manange_sensors')"
            @click="handleOpenTransmitterSensorsDialog(scope.row)"
          )
          img.cursor-pointer.ml-1(
            src="@assets/actions/battery-charging-icon.svg"
            :title="$t('transmitters.view_status')"
            @click="handleOpenViewBatteryDialog(scope.row)"
          )
</template>

<script>
import {
  filterUtils,
  MAX_FIELD_LENGTH,
} from "@utils/filterUtils";
import { routerUtils } from "@utils/router";
import { general } from "@src/services/dynamicViews/general";
import { mapMutations, mapState } from "vuex";
import BatteryIcon from '@components/_shared/BatteryIcon.vue';

export default {
  name: "TransmittersViewTable",
  mixins: [filterUtils, routerUtils,general],

  components: {
    BatteryIcon
  },

  props: {
    transmitters: {
      type: Array,
    },
  },

  data() {
    return {
      MAX_FIELD_LENGTH,
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
  },

  methods: {
    ...mapMutations("dialog", [
      "showEditTransmitterDialog",
      "showEditTransmitterConfigDialog",
      "showViewStatusDialog",
      "showTransmitterSensorsDialog"
    ]),

    ...mapMutations("transmitter", ["setTransmitter"]),

    handleOpenEditTransmitter(transmitter){
      this.showEditTransmitterDialog();
      this.setTransmitter(transmitter);
    },

    handleOpenEditTransmitterConfig(transmitter){
      this.showEditTransmitterConfigDialog();
      this.setTransmitter(transmitter);
    },

    handleOpenViewBatteryDialog(transmitter){
      this.setTransmitter(transmitter);
      this.showViewStatusDialog();
    },

    handleOpenTransmitterSensorsDialog(transmitter) {
      this.setTransmitter(transmitter);
      this.showTransmitterSensorsDialog();
    },

    buildDateTime(dateValue) {
      const localDate = new Date(dateValue);
      const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      const day = localDate.getDate().toString().padStart(2, '0');
      const monthName = months[localDate.getMonth()];
      const year = localDate.getFullYear();

      const timeStr = localDate.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });

      return `${timeStr} on ${day} ${monthName} ${year}`;
    },
  }
};
</script>

<style lang="scss" scoped>
.grid-buttons {
  display: inline-grid;
  grid-template-rows: 40px 40px;
  grid-template-columns: 40px 40px;
  grid-gap: 3px;

  img {
    margin: auto 0;
  }
}
</style>
